import { canApproveForm } from '../onboarding-action-policy.service';
import templateUrl from './ca-w4.component.html';
import moment from 'moment';
import { PreviewSignatureModal } from '../preview-signature-modal/preview-signature-modal.component';
import { InfoModal } from '../info-modal/info-modal.component';
import { OwnerPreviewSignatureModal } from '../preview-signature-modal/owner-preview-signature-modal.component';


export const CaW4Component = {
    templateUrl,
    controller: CAw4Controller,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        ownerView: "<",
        owner: "<",
        employee: "<",
        employeeProfile: "<",
        profile: "<",
        employeeBankInfo: "<",
        provinces: "<",
        application: "<",
        genderOptions: "<",
        userInputs: "<",
        savedInputs: "<",
        maritalStatus: "<",
        addlInputs: "<",
        ownerInfo: "<",
        stateTaxInfo: "<",
        showSignaturePopup: "<",
        close: "&",
        dismiss: "&"
    }
};


function CAw4Controller(onboardingActionPolicy, onboardingDocumentService, $state, $scope, $uibModal, $q, utilityService, localeService, onboardingDocumentViewService, employeeService) {
    'ngInject';
    const vm = this;
    // APEX-977: read-only View mode (locked forms) - hides inline Edit, keeps fields disabled.
    vm.isViewOnly = () => !!vm.application && onboardingActionPolicy.getButtonTitle('2', vm.application) === 'View';
    vm.taxForm;

    vm.onPreview = onPreview;
    vm.onPreviewInPage = onPreviewInPage;
    vm.onDocDownload = onDocDownload;
    vm.onSubmit = onSubmit;
    vm.onShowI9 = onShowI9;
    vm.onClose = onClose;
    vm.onShowFederalW4 = onShowFederalW4;
    vm.onRequestReview = onRequestReview;
    vm.onSave = onSave;
    vm.revealSSNChar = revealSSNChar;
    vm.revealFEINChar = revealFEINChar;
    vm.retrieveLocale = retrieveLocale;
    vm.retrieveLocaleTranslations = retrieveLocaleTranslations;
    vm.ssnIsValidated = ssnIsValidated;
    vm.ssnBlur = ssnBlur;
    vm.syncFormToProfile = syncFormToProfile;
    vm.stateWitholdingTypeID = 5;
    vm.reqReview = false;
    vm.isSigned = false;
    vm.prefilled = false;
    vm.disableEmpFields = true;
    vm.disableEmprFields = false;
    vm.editable = true;
    vm.isSaved = false;
    vm.savedData = false;
    vm.showSavedNotification = false;
    vm.previewUrl;
    vm.fillLockedInfo = fillLockedInfo;
    vm.onEditClicked = onEditClicked;
    vm.state = {
        view: 'W4'
    };

    vm.maritalStatusMapping = [
        { id: 4, status: 'S' },
        { id: 5, status: 'M' },
        { id: 6, status: 'H' }];


    vm.$onInit = function () {
        console.log(vm.resolve);
        // spread resolve variables
        if (vm.resolve) {
            Object.assign(vm, vm.resolve);
        }

        vm.reqReview = false;
        vm.date = moment(new Date(), 'MM/DD/YYYY').toDate();
        vm.stateProvinces = this.provinces;
        vm.userProfile = this.profile;
        //get locale
        vm.retrieveLocale()
            .then(function (locale) {
                console.log(locale);
                return vm.retrieveLocaleTranslations(locale.localeID);
            })
            .then(function (translations) {
                vm.employeeBankInfo.Translations = translations;
            });
        //make application editable only if submitted doc is empty
        //if (this.application) {
        //    vm.editable = !(vm.application && vm.application.ProvinceW4DocumentId != null);
        //}

        //load application data
        if (vm.savedInputs != null && vm.savedInputs.FullName != null && !vm.ownerView) {
            console.log(vm.savedInputs);
            vm.savedData = true;
            vm.showSavedNotification = true;
            fillEmployee(vm.savedInputs);
            //default to user profile
            vm.employeeName = [vm.employeeProfile.FirstName, vm.employeeProfile.MiddleName, vm.employeeProfile.LastName].filter(Boolean).join(' ');
            vm.employeeSsn = vm.employeeBankInfo.CurrentSSN;
            vm.address = [vm.profile.HomeAddress.StreetLine1, vm.profile.HomeAddress.StreetLine2, vm.profile.HomeAddress.AptNum].filter(Boolean).join(', ');
            vm.city = vm.profile.HomeAddress.City;
            vm.stateProvince = vm.stateProvinces.find(x => x.StateProvinceID === this.profile.HomeAddress?.StateProvinceID);
            vm.zipCode = vm.profile.HomeAddress.PostalCode;
        } else if (vm.userInputs != null && vm.userInputs.FullName != null) {
            //prefill this.userInputs
            if (this.application) {
                vm.editable = !(this.application && this.application.HasSW4Form !== null && this.application.ProvinceW4 !== 'Review' && this.application.ProvinceW4 !== 'Submitted' && this.application.ProvinceW4 !== 'Pending');
            }
            fillEmployee(vm.userInputs);
            if (vm.application.ProvinceW4 === "Pending") {
                fillLockedInfo();
            }
        } else {
            //prefill user info
            //vm.taxForm.$setDirty();
            vm.employeeName = [vm.employeeProfile.FirstName, vm.employeeProfile.MiddleName, vm.employeeProfile.LastName].filter(Boolean).join(' ');
            vm.employeeSsn = vm.employeeBankInfo.CurrentSSN;
            vm.address = [vm.profile.HomeAddress.StreetLine1, vm.profile.HomeAddress.StreetLine2, vm.profile.HomeAddress.AptNum].filter(Boolean).join(', ');
            vm.city = vm.profile.HomeAddress.City;
            vm.stateProvince = vm.stateProvinces.find(x => x.StateProvinceID === this.profile.HomeAddress?.StateProvinceID);
            vm.zipCode = vm.profile.HomeAddress.PostalCode;
        }
        if (vm.application.ApplicationStatus === 'Approved' || vm.application.ApplicationStatus === 'Submitted') {
            vm.editable = false;
        }
        if (vm.ownerView) {
            if (this.userInputs != null && this.userInputs.Employername != null) { //owner inputs
                let split = this.userInputs.Employername.split(', ', 2);
                vm.employerName = split[0];
                vm.employerAddress = this.userInputs.Employername.substring(this.userInputs.Employername.indexOf(', ') + 1);
                vm.ceptan = this.userInputs.CaliforniaEmpTaxAccNo
            } else if (vm.ownerInfo) {
                if (vm.ownerInfo.ShippingAddress) {
                    vm.employerAddress = [vm.ownerInfo.ShippingAddress.StreetLine1, vm.ownerInfo.ShippingAddress.StreetLine2, vm.ownerInfo.ShippingAddress.AptNum, vm.ownerInfo.ShippingAddress.City, vm.ownerInfo.ShippingAddress.StateName, vm.ownerInfo.ShippingAddress.PostalCode, vm.ownerInfo.ShippingAddress.CountryName].filter(Boolean).join(', ');
                }
                vm.employerName = vm.ownerInfo.LegalBusinessName || vm.ownerInfo.ClientName;
                let sit = vm.stateTaxInfo?.find(x => x.State === String(vm.employeeBankInfo?.StateToBeTaxedIn) && x.Name === 'State Income Tax');
                vm.ceptan = sit?.Value ?? '';
            }
        }
        if (vm.ownerView && vm.showSignaturePopup) {
            return onPreview();
        }
        vm.editable = resolveEditable();
    }

    function resolveEditable() {
        const appStatus = vm.application.ApplicationStatus;
        const formStatus = vm.application.ProvinceW4;  // ? ProvinceW4

        // ReviewRequired: always directly editable so the employee can fix it
        if (formStatus === 'ReviewRequired') return true;
        if (appStatus === 'Approved' || appStatus === 'Submitted') return false;
        // Submitted or Approved form: locked so the Edit button shows
        if (formStatus === 'Submitted' || formStatus === 'Approved') return false;
        if (appStatus === 'Pending') {
            // Active employees: skip edit button, directly editable
            // Pending employees (new hire): start locked so edit button is shown
            return formStatus === 'Pending' || vm.application.EmployeeStatus !== 'Pending';
        }

        return !vm.application.HasSW4Form              // ? HasSW4Form
            || formStatus === 'Pending'
            || formStatus === 'ReviewRequired';
    }


    function fillLockedInfo() {
        vm.employeeName = [vm.employeeProfile.FirstName, vm.employeeProfile.MiddleName, vm.employeeProfile.LastName].filter(Boolean).join(' ');
        vm.employeeSsn = vm.employeeBankInfo.CurrentSSN;
        vm.address = [vm.profile.HomeAddress.StreetLine1, vm.profile.HomeAddress.StreetLine2, vm.profile.HomeAddress.AptNum].filter(Boolean).join(', ');
        vm.city = vm.profile.HomeAddress.City;
        vm.stateProvince = vm.stateProvinces.find(x => x.StateProvinceID === vm.profile.HomeAddress?.StateProvinceID);
        vm.zipCode = vm.profile.HomeAddress.PostalCode;
    }


    function onEditClicked() {
        vm.editable = !vm.editable;
        if (vm.employeeProfile != null && vm.employeeProfile.EmployeeStatusID === 1 && vm.application.ApplicationStatus === 'Pending') {
            vm.employeeName = [vm.employeeProfile.FirstName, vm.employeeProfile.MiddleName, vm.employeeProfile.LastName].filter(Boolean).join(' ');
            vm.employeeSsn = vm.employeeBankInfo.CurrentSSN;
            vm.address = [vm.profile.HomeAddress.StreetLine1, vm.profile.HomeAddress.StreetLine2, vm.profile.HomeAddress.AptNum].filter(Boolean).join(', ');
            vm.city = vm.profile.HomeAddress.City;
            vm.stateProvince = vm.stateProvinces.find(x => x.StateProvinceID === vm.profile.HomeAddress?.StateProvinceID);
            vm.zipCode = vm.profile.HomeAddress.PostalCode;
        }
    }

    function fillEmployee(data) {
        vm.employeeName = data.FullName;
        vm.employeeSsn = data.EmployeeSocialSecurityNumber;
        vm.address = [vm.profile.HomeAddress.StreetLine1, vm.profile.HomeAddress.StreetLine2, vm.profile.HomeAddress.AptNum].filter(Boolean).join(', ');
        vm.city = data.City;
        vm.stateProvince = vm.stateProvinces.find(x => x.StateProvinceID === vm.employeeBankInfo?.StateToBeTaxedIn);
        vm.zipCode = data.ZipCode;
        //vm.zipCode = data.EmployeeZip;
        vm.filingStatus = data.FilingStatus;
        vm.regularWithholding = data.RegularWithholdingAllowance != null ? Number(data.RegularWithholdingAllowance) : null;
        vm.estimatedDeductions = data.EstimatedDeductions != null ? Number(data.EstimatedDeductions) : null;
        vm.totalAllowances = data.TotalAllowances != null ? Number(data.TotalAllowances) : null;
        vm.addlAmount = data.AddlAmount != null ? Number(data.AddlAmount) : null;
        vm.whexempt = data.WHexempt === 'true';
        vm.notsub2wh = data.NotSubj2WH === 'true';

        if (data.Signature) {
            vm.signimage = data.Signature;
            vm.isSigned = true;
            vm.prefilled = true;
        }

        vm.date = moment(data.Date, 'MM/DD/YYYY').toDate();
    }

    //event to track if user changed any form data
    $scope.$watch('vm.taxForm.$dirty', function (value) {
        if (value) {
            vm.prefilled = false;
        }
    }, false);

    //request review
    function onRequestReview() {
        const trans = onboardingDocumentService.saveComment({
            ApplicationId: vm.application.ApplicationId,
            UserName: vm.owner.UserName,
            Text: vm.commentText,
        }).then((res) => {
            if (res) return onboardingDocumentService.setReviewRequired(vm.employee.EmployeeID, '2');
        }).then(() => {
            vm.close({ $value: 'ok' });
        }).catch((err) => {
            return $q.reject(err);
        });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, 'Request review failed')
        );
    }

    //info document
    function onDocDownload(pages) {
        utilityService.showLoading();
        return onboardingDocumentService.retrieveTemplate(vm.employee.UserName, '1', '7', pages).then(function (result) {
            utilityService.hideLoading();
            return result;
        }).then(function () {
            utilityService.hideLoading();
        });

    }

    function syncFormToProfile() {


        let map1 = vm.maritalStatusMapping.find(x => x.status === vm.filingStatus)?.id;
        vm.employeeBankInfo.StateMaritalStatusID = vm.maritalStatus.reduce(function (result, item, index) {
            if (item.MaritalStatusID === map1) {
                result = item.MaritalStatusID;
            }
            return result;
        }, {});

        let withholding = vm.employeeBankInfo.EmployeeWithholdingInfos.find(x => x.WithholdingTypeID === vm.stateWitholdingTypeID);
        if (withholding != null && vm.addlAmount != null) {
            withholding = { EmployeeId: vm.employee.EmployeeID, WithholdingTypeID: vm.stateWitholdingTypeID, AdditionalWithholdingAmount: vm.addlAmount };
        } else if (withholding != null && vm.addlAmount == null) {
            withholding = null;
            vm.employeeBankInfo.employeeExtraWithHolding = vm.employeeBankInfo.EmployeeWithholdingInfos.filter(function (x) {
                return x.WithholdingTypeID !== vm.stateWitholdingTypeID;
            });
        } else if (withholding == null && vm.addlAmount != null) {
            withholding = { EmployeeId: vm.employee.EmployeeID, WithholdingTypeID: vm.stateWitholdingTypeID, AdditionalWithholdingAmount: vm.addlAmount };
        }

        if (withholding != null) {
            vm.employeeBankInfo.EmployeeWithholdingInfos = vm.employeeBankInfo.EmployeeWithholdingInfos.filter(function (x) {
                return x.WithholdingTypeID !== vm.stateWitholdingTypeID;
            });
            vm.employeeBankInfo.EmployeeWithholdingInfos.push(withholding);
        }

        //vm.employeeBankInfo.WithholdingState = vm.addlAmount;
        vm.employeeBankInfo.RegularWithholdingAllowances = vm.regularWithholding;
        vm.employeeBankInfo.WithholdingState = vm.totalAllowances;
        vm.employeeBankInfo.DependentAllowances = vm.estimatedDeductions;
        vm.employeeBankInfo.StateTaxExempt = vm.whexempt || vm.notsub2wh;

        //vm.employeeBankInfo.StateMaritalStatusID = vm.maritalStatus
    }

    //preview popup
    function onPreviewInPage() {
        if (vm.taxForm && vm.taxForm.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return;
        }
        utilityService.showLoading();
        let formData = {
            RequestTypeId: '2',
            IsI9EmployeeMode: !vm.ownerView,
            FullName: vm.employeeName,
            EmployeeSocialSecurityNumber: vm.employeeSsn,
            Address: vm.address,
            City: vm.city,
            State: vm.stateProvince.Abbr,
            ZipCode: vm.zipCode,
            FilingStatus: vm.filingStatus,
            RegularWithholdingAllowance: Number(vm.regularWithholding) || 0,
            EstimatedDeductions: Number(vm.estimatedDeductions) || 0,
            TotalAllowances: Number(vm.totalAllowances) || 0,
            AddlAmount: Number(vm.addlAmount) || 0,
            WHexempt: vm.whexempt,
            NotSubj2WH: vm.notsub2wh,
            Date: moment(vm.date, 'MM/DD/YYYY').format('MM/DD/YYYY'),
            //Signature: vm.signimage,
        };
        if (vm.ownerView) {
            let ownerData = {
                CaliforniaEmpTaxAccNo: vm.ceptan,
                Employername: vm.employerName + ', ' + vm.employerAddress
            }
            formData = { ...formData, ...ownerData }
        }
        return onboardingDocumentService.previewUrl(vm.employee.UserName, formData, 7)
            .then(function (result) {
                utilityService.hideLoading();
                vm.previewUrl = result;
                return $uibModal.open({
                    ...PreviewSignatureModal,
                    resolve: {
                        title: () => "California W4",
                        previewUrl: () => {
                            return vm.previewUrl;
                        }
                    }
                }).result
            }).then(function (data) {
                console.log(data);
                vm.signimage = data.dataUrl;
                vm.isSigned = data.dataUrl != null;
                //vm.ISPreview = true;
                return onSubmit();
            }).catch((err) => {
                console.log(err);
                utilityService.hideLoading();
            });

    }

    //save
    function onSave() {
        utilityService.showLoading();
        let formData = {
            RequestTypeId: '2',
            IsI9EmployeeMode: !vm.ownerView,
            FullName: vm.employeeName,
            EmployeeSocialSecurityNumber: vm.employeeSsn,
            Address: vm.address,
            City: vm.city,
            State: vm.stateProvince.Abbr,
            ZipCode: vm.zipCode,
            FilingStatus: vm.filingStatus,
            RegularWithholdingAllowance: Number(vm.regularWithholding) || 0,
            EstimatedDeductions: Number(vm.estimatedDeductions) || 0,
            TotalAllowances: Number(vm.totalAllowances) || 0,
            AddlAmount: Number(vm.addlAmount) || 0,
            WHexempt: vm.whexempt,
            NotSubj2WH: vm.notsub2wh,
            Date: moment(vm.date, 'MM/DD/YYYY').format('MM/DD/YYYY'),
        };
        return onboardingDocumentService.save(vm.employee.UserName, formData, 7).then(function () {
            vm.isSaved = true;
            vm.showSavedNotification = true;
            vm.taxForm.$setPristine();
            return utilityService.hideLoading();
        });
    }

    function onApprove() {
        let approvePromise = onboardingDocumentService.approveOnboardingForm(vm.application.ApplicationId, "2");
        const trans = $q.all(approvePromise).then((res) => {
            if (res) {
                vm.onShowI9();
            }
        }).catch((err) => {
            return $q.reject(err);
        });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, "Approve failed")
        );
    }
    //submit
    function onSubmit() {

        if (vm.taxForm && vm.taxForm.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return;
        }
        //utilityService.showLoading();
        let updatePromises = [];
        let submitApplicationPromise = $q.defer();
        vm.isDirtyEdit = vm.employeeProfile != null && (vm.employeeProfile.EmployeeStatusID !== 2) && vm.application.ApplicationStatus === 'Pending';
        const isPendingResubmit = vm.application.ApplicationStatus === 'Pending' && (vm.application.ProvinceW4 === 'Approved' || vm.application.ProvinceW4 === 'Pending');
        if ((vm.taxForm && vm.taxForm.$dirty) || vm.savedData || vm.isSaved || vm.ownerView || vm.isDirtyEdit || isPendingResubmit || vm.isSigned || vm.application.ProvinceW4 === 'ReviewRequired') {
            if (!vm.isSigned) {
                utilityService.hideLoading();
                alert("Preview and Signature are required");
            }
            if (!vm.signimage) {
                utilityService.hideLoading();
                alert("Signature is required");
                return;
            }

            let formData = {
                RequestTypeId: '2',
                IsI9EmployeeMode: !vm.ownerView,
                FullName: vm.employeeName,
                EmployeeSocialSecurityNumber: vm.employeeSsn,
                Address: vm.address,
                City: vm.city,
                State: vm.stateProvince.Abbr,
                ZipCode: vm.zipCode,
                FilingStatus: vm.filingStatus,
                RegularWithholdingAllowance: Number(vm.regularWithholding) || 0,
                EstimatedDeductions: Number(vm.estimatedDeductions) || 0,
                TotalAllowances: Number(vm.totalAllowances) || 0,
                AddlAmount: Number(vm.addlAmount) || 0,
                WHexempt: vm.whexempt,
                NotSubj2WH: vm.notsub2wh,
                Date: moment(vm.date, 'MM/DD/YYYY').format('MM/DD/YYYY'),
                Signature: vm.signimage,
            };
            if (vm.ownerView) {
                let ownerData = {
                    CaliforniaEmpTaxAccNo: vm.ceptan,
                    Employername: vm.employerName + ', ' + vm.employerAddress
                }
                formData = { ...formData, ...ownerData }
            }

            submitApplicationPromise = onboardingDocumentService.submit(vm.employee.UserName, formData, 7)
            if (!vm.ownerView) {
                syncFormToProfile();
                updatePromises.push(employeeService.updateEmployeeBankInfo(vm.employee.EmployeeID, vm.employeeBankInfo, true));
            }
            updatePromises.push(submitApplicationPromise);
        }
        if (!Array.isArray(updatePromises) || updatePromises.length === 0) {
            if (vm.ownerView) {
                return onApprove();
            } else {
                return onShowI9();
            }

        }

        const trans = $q.all(updatePromises).then((res) => {
            if (res) {
                if (vm.ownerView) {
                    return onApprove();
                } else {
                    return onShowI9();
                }
            }
        }).catch((err) => {
            return $q.reject(err);
        });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, "Save failed")
        );
    }

    //preview
    function onPreview() {
        if (vm.taxForm && vm.taxForm.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return;
        }
        utilityService.showLoading();
        let formData = {
            RequestTypeId: '2',
            IsI9EmployeeMode: !vm.ownerView,
            FullName: vm.employeeName,
            EmployeeSocialSecurityNumber: vm.employeeSsn,
            Address: vm.address,
            City: vm.city,
            State: vm.stateProvince.Abbr,
            ZipCode: vm.zipCode,
            FilingStatus: vm.filingStatus,
            RegularWithholdingAllowance: Number(vm.regularWithholding) || 0,
            EstimatedDeductions: Number(vm.estimatedDeductions) || 0,
            TotalAllowances: Number(vm.totalAllowances) || 0,
            AddlAmount: Number(vm.addlAmount) || 0,
            WHexempt: vm.whexempt,
            NotSubj2WH: vm.notsub2wh,
            Date: moment(vm.date, 'MM/DD/YYYY').format('MM/DD/YYYY'),
            Signature: vm.signimage
        };
        if (vm.ownerView) {
            let ownerData = {
                CaliforniaEmpTaxAccNo: vm.ceptan,
                Employername: vm.employerName + ', ' + vm.employerAddress
            }
            formData = { ...formData, ...ownerData }
        }

        return onboardingDocumentService.previewUrl(vm.employee.UserName, formData, 7)
            .then(function (result) {
                utilityService.hideLoading();
                vm.previewUrl = result;
                return $uibModal.open({
                    ...OwnerPreviewSignatureModal,
                    resolve: {
                        title: () => "California W4",
                        previewUrl: () => {
                            return vm.previewUrl;
                        },
                        allowApprove: () => {
                            return canApproveForm(vm.application, '2');
                        },
                        allowSign: () => {
                            return false;
                        }, //for pages without signature
                        showSignaturePopup: () => {
                            return vm.showSignaturePopup;
                        }
                    }
                }).result
            }).then(function (data) {
                console.log(data);
                if (data === 'terminate' && vm.showSignaturePopup) {
                    return vm.close({ $value: 'ok' });
                }
                if (data.success) {
                    vm.employerSignimage = data.dataUrl;
                    vm.isSigned = true; //employer version
                    return onSubmit();
                }
            }).catch((err) => {
                console.log(err);
                utilityService.hideLoading();
            });

    }

    //capture esc key press
    $scope.$on('modal.closing', function (event, reason, closed) {
        if (reason !== 'ok') {
            return onClose(event);
        }
    });

    function onClose(event) {
        if (vm.taxForm && vm.taxForm.$dirty) {
            /* vm.close({ $value: 'cancel' });*/
            event.preventDefault();
            $uibModal.open({
                ...InfoModal,
                resolve: {
                    notification: () => {
                        return "Your form is not completed yet. Do you want to leave?"
                    },
                    state: () => {
                        return "application-status";
                    }
                },
                controller: function ConfirmModalController($uibModalInstance) {
                    'ngInject'
                    this.close = function () {
                        $uibModalInstance.dismiss();
                    };
                },
                size: 'sm',
                backdrop: 'static'
            }).result.then(function (data) {
                console.log(data);
                if (data === 'ok') {
                    vm.close({ $value: 'ok' });
                }
            }, function (dismiss) {
                console.log(dismiss);
            });
        }
    }



    function onShowI9() {
        vm.close({ $value: 'ok' });
    }

    function onShowFederalW4() {

    }

    function retrieveLocaleTranslations(localeID) {
        return localeService.retrieveLocaleTranslations(localeID)
            .then(function (translations) {
                return translations;
            });
    }

    function retrieveLocale() {
        return localeService.retrieveLocales()
            .then(function (locales) {
                console.log(vm.employeeBankInfo.CountryID);
                return locales.filter(function (locale) {
                    console.log(vm.employeeBankInfo.CountryID);
                    return locale.countryID === vm.employeeBankInfo.CountryID;
                })[0] || localeService.retrieveCurrentLocale();
            })
            .then(function (locale) {
                if (locale) {
                    return locale;
                }
            });
    }

    function ssnIsValidated() {
        if (vm.employeeBankInfo != null && vm.employeeBankInfo.ssnChanged) {
            if ((vm.employeeBankInfo.SSN || "") !== (vm.employeeBankInfo.confirmSSN || "")) {
                return false;
            }
        }
        return true;
    }

    function ssnBlur() {
        if (vm.employeeBankInfo != null && vm.employeeBankInfo.SSN !== vm.employeeBankInfo.originalSSN) {
            vm.employeeBankInfo.ssnChanged = true;
        } else {
            vm.employeeBankInfo.ssnChanged = false;
        }
    }

    function revealSSNChar(ssn, char, i) {
        return i > 4;
    }
    function revealFEINChar(fein, char, i) {
        return i > 4;
    }
}


export const CAW4Modal = {
    component: "apexCAW4Modal",
    windowClass: 'xx-dialog pagespinner',
    size: 'lg',
    backdrop: 'static'
}
